module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium.e3aae62.woff2";